import { CheckCircle2, Circle, Clock } from 'lucide-react';

function StatsWidget({ stats, theme }) {
  const widgets = [
    {
      label: 'Overall Progress',
      value: `${stats.completion_percentage}%`,
      icon: CheckCircle2,
      color: 'bg-[#81B29A]',
      testId: 'stat-progress',
    },
    {
      label: 'To Do',
      value: stats.todo_tasks,
      icon: Circle,
      color: 'bg-stone-400',
      testId: 'stat-todo',
    },
    {
      label: 'In Progress',
      value: stats.in_progress_tasks,
      icon: Clock,
      color: 'bg-[#F2CC8F]',
      testId: 'stat-in-progress',
    },
    {
      label: 'Completed',
      value: stats.completed_tasks,
      icon: CheckCircle2,
      color: 'bg-[#81B29A]',
      testId: 'stat-completed',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4" data-testid="stats-dashboard">
      {widgets.map((widget, idx) => {
        const Icon = widget.icon;
        return (
          <div
            key={idx}
            className={`${theme?.colors.surface || 'bg-white'} border ${theme?.colors.border || 'border-stone-200'} rounded-xl p-3 sm:p-6 shadow-sm`}
            data-testid={widget.testId}
          >
            <div className="flex items-center justify-between mb-1 sm:mb-3">
              <p
                className={`text-[10px] sm:text-sm uppercase tracking-[0.15em] sm:tracking-[0.2em] font-medium ${theme?.colors.textSecondary || 'text-stone-500'}`}
                style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
              >
                {widget.label}
              </p>
              <div className={`${widget.color} p-1.5 sm:p-2 rounded-lg`}>
                <Icon className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
              </div>
            </div>
            <p
              className={`text-2xl sm:text-4xl font-medium ${theme?.colors.textPrimary || 'text-stone-900'}`}
              style={{ fontFamily: 'Manrope, sans-serif' }}
            >
              {widget.value}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default StatsWidget;